import { addLocale } from "primereact/api";

export const GetDateLocal =(datedb: Date) => {
    let lastdate = new Date(datedb);
    let month = lastdate.getMonth() + 1;
    let monthstring = month.toString();
  
    if (month < 10) {
        monthstring = '0' + month
    }
  
    let day = ('0' + lastdate.getUTCDate()).slice(-2);
    let year = ('0' + lastdate.getFullYear()).slice(-4);
    //let dateOfIssue = year + '-' + monthstring + '-' + day;
    let dateOfIssue =   day + '-' + monthstring + '-' + year;
  
    return dateOfIssue;
}

export const setEsLocale: () => void = () => {
    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "mi�rcoles", "jueves", "viernes", "s�bado",],
        dayNamesShort: ["dom", "lun", "mar", "mi�", "jue", "vie", "s�b"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic",],
        today: "este mes", clear: "x",
    });
}